import { NgModule } from '@angular/core';
import { BitwisePipe } from './bitwise.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [BitwisePipe],
	imports: [CommonModule],
	exports: [BitwisePipe]
})
export class WmPipesModule {}
